export const m365_info = 'Microsoft 365 is a suite of desktop and web-based productivity tools and cloud services. Its features include: Outlook, Calendars, OneDrive, Word, Excel, and more. '

export const m365_md = `
# Microsoft 365
*Last Updated: July 14, 2025*

## Overview

Microsoft 365 (formerly Office 365) is a suite of productivity tools hosted by Microsoft. In addition to email and calendaring features, Microsoft 365 provides multiple applications such as OneDrive, the Office Suite and additional productivity tools.

## Benefits
- **Easy Collaboration**: You can easily communicate and collaborate on documents and projects with colleagues.
- **Secure Cloud Storage**: OneDrive and SharePoint provide secure cloud storage for personal and shared documents.
- **Accessibility**: The M365 suite can be accessed from both the desktop applications (recommended) and the web browser.

## Requirements
- A user account with an applicable license.
- An up to date version of Windows.

## Getting Started
- [Download the desktop apps](https://portal.office.com/OLS/MySoftware.aspx)
- [Access the browser apps](https://m365.cloud.microsoft/apps/)

## Some Notable Features
- **M365 Desktop Apps**: Word, Excel, PowerPoint, Access, Publisher, Outlook, and OneDrive for Business.
- **Office Apps for Mobile Devices**: You can download most of the Office apps for use on your mobile device. Downloading Outlook and Teams is a great place to start if you're interested.
- **OneDrive for Business**: This service attaches cloud storage for your desktop, documents, and photos to your work account. You files are backed up in case of data loss or if you migrate to a new computer.
- **M365 Groups**: Groups provide a shared workspace for email, conversations, files, and events.
- **Power Automate**: This tool allows you to automate workflows between different applications. For example, you can automatically start and approval process and send an email notification whenever someone fill out a form.
- **Forms**: Forms allow you to create surveys, registrations, data collection forms, and more. Results can be viewed in real time in the web portal or Excel. Forms can be integrated with Power Automate to automate workflows.
- **Teams**: Teams is a chat-based app that allows for quick and easy collaboration between people. Files can be easily shared and collaborated on. Creating a M365 group can facilitate efficient collaboration in Teams on projects involving many people.

## Support
- Contact our IT Help Desk

`